import { defineStore } from "pinia";
import Http from '../utils/http';

export const useTemplatesStore = defineStore("templates", {
    state: () => ({
        templates: [],
        situations: [],
        parameters: []
    }),

    actions: {
        setTemplates(templates) {
            this.templates = [];

            templates.forEach(template => this.templates.push({
                id: template['id'],
                key: template['key']
            }));
        },

        setSituations(situations) {
            this.situations = [];

            situations.forEach(situation => this.situations.push({
                id: situation['id'],
                name: situation['name']
            }));
        },

        setParameters(parameters) {
            this.parameters = [];

            parameters.forEach(parameter => this.parameters.push({
                id: parameter['id'],
                key: parameter['key'],
                minValue: parameter['min_value'],
                maxValue: parameter['max_value'],
                values: parameter['values'],
                unit: parameter['unit']
            }));
        },
        
        loadTemplates() {
            Http.get('/api/templates')
                .then(response => {
                    const templates = response.data || [];
                    this.setTemplates(templates);
                })
                .catch(error => console.error(error));
        },

        loadSituations(templateId) {
            Http.get(`/api/templates/${templateId}/situations`)
                .then(response => {
                    const situations = response.data || [];
                    this.setSituations(situations);
                })
                .catch(error => console.error(error));
        },

        loadParameters(payload) {
            Http.get(`/api/templates/${payload.templateId}/parameters/${payload.type}`)
                .then(response => {
                    const parameters = response.data || [];
                    this.setParameters(parameters);
                })
                .catch(error => console.error(error));
        },

        clearState() {
            this.$reset();
        },
    }
})